"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.captlizeFirstLetterOnly = exports.formatTotalCost = exports.getNormalizedCost = exports.getAppDataFromLegacyOrUpdatedFields = exports.getAppUpdateRequestBody = exports.WALLET_SCOPE_TYPE = exports.GET_WALLET_AUTH = exports.CTA_BUTTON_STYLE = exports.APP_THEME = exports.USER_MESSAGE_TEMPLATE = exports.PROCESSING_LOADER_STATE = exports.AUTH_PROVIDER_STATE = exports.isValidOrigin = exports.getUserInfo = exports.validate = exports.emailRegx = void 0;
const password_validator_1 = __importDefault(require("password-validator"));
const aws_amplify_1 = require("aws-amplify");
const constants_1 = require("../constants");
const bignumber_js_1 = require("bignumber.js");
const constants_2 = require("../constants");
const frontend_utils_1 = require("frontend-utils");
const logger_1 = require("frontend-utils/logger");
exports.emailRegx = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,63}$/i;
const passSchema = new password_validator_1.default();
const otpSchema = new password_validator_1.default();
passSchema
    .has()
    .min(8, constants_1.MIN_PASSWORD_LENGTH_MSG)
    .uppercase(1, constants_1.MIN_UPPERCASE_MSG)
    .symbols(1, constants_1.MIN_SYMBOLS_MSG)
    .digits(1, constants_1.MIN_DIGITS_MSG);
otpSchema
    .is()
    .min(6, constants_1.MIN_OTP_LENGTH_MSG)
    .max(6, constants_1.MAX_OTP_LENGTH_MSG)
    .has()
    .not()
    .letters(0, constants_1.NO_LETTERS_MSG)
    .symbols(0, constants_1.NO_SYMBOLS_MSG)
    .spaces(0, constants_1.NO_SPACES_MSG);
const validate = (fieldType, value) => {
    var _a, _b;
    const errors = {};
    switch (fieldType) {
        case "email":
            value = value;
            errors[fieldType] = constants_1.INVALID_EMAIL_MSG;
            if (value && value.match(exports.emailRegx))
                errors[fieldType] = null;
            break;
        case "password":
            value = value;
            errors.password =
                ((_a = passSchema.validate(value, { details: true })[0]) === null || _a === void 0 ? void 0 : _a.message) ||
                    null;
            break;
        case "name":
            if (!value)
                errors[fieldType] = constants_1.FIELD_REQUIRED_MSG;
            else
                errors[fieldType] = null;
            break;
        case "rawAppData":
            value = value;
            if (value && value.type === constants_1.APP_TYPE_CRYPTOGRAPHY && !value.algorithm)
                errors["algorithm"] = constants_1.FIELD_REQUIRED_MSG;
            if (value && value.type === constants_1.APP_TYPE_BLOCKCHAIN && !value.network)
                errors["network"] = constants_1.FIELD_REQUIRED_MSG;
            if (value &&
                (value.type === constants_1.APP_TYPE_CRYPTOGRAPHY ||
                    value.type === constants_1.APP_TYPE_BLOCKCHAIN) &&
                !value.environment)
                errors["environment"] = constants_1.FIELD_REQUIRED_MSG;
            if (value && value.type === constants_1.APP_TYPE_IDENTITY && !value.identityType)
                errors["identityType"] = constants_1.FIELD_REQUIRED_MSG;
            else
                errors[fieldType] = null;
            break;
        case "OTP":
            value = value;
            errors.OTP =
                ((_b = otpSchema.validate(value, { details: true })[0]) === null || _b === void 0 ? void 0 : _b.message) ||
                    null;
            break;
        default:
            errors[fieldType] = null;
            break;
    }
    return errors;
};
exports.validate = validate;
const getUserInfo = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const { attributes = {} } = yield aws_amplify_1.Auth.currentAuthenticatedUser();
        const { email = "" } = attributes;
        return new frontend_utils_1.ParsedUser({ developerEmail: email });
    }
    catch (err) {
        if (err === constants_1.AMPLIFY_NOT_AUTHENTICATED_ERROR) {
            window.location.href = "/";
        }
        logger_1.logger.debug("getUserInfo Error", err);
    }
});
exports.getUserInfo = getUserInfo;
const isValidOrigin = (origin) => {
    // Regular expression pattern to match a URL without a path
    const urlPattern = /^(https?:\/\/)(([\w.-]+\*?\.)+[a-zA-Z]{2,}|localhost|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})(:\d+)?$/i;
    // Check if the URL matches the pattern
    return urlPattern.test(origin);
};
exports.isValidOrigin = isValidOrigin;
var AUTH_PROVIDER_STATE;
(function (AUTH_PROVIDER_STATE) {
    AUTH_PROVIDER_STATE["ENABLED"] = "ENABLED";
    AUTH_PROVIDER_STATE["DISABLED"] = "DISABLED";
})(AUTH_PROVIDER_STATE || (exports.AUTH_PROVIDER_STATE = AUTH_PROVIDER_STATE = {}));
var PROCESSING_LOADER_STATE;
(function (PROCESSING_LOADER_STATE) {
    PROCESSING_LOADER_STATE["ENABLED"] = "ENABLED";
    PROCESSING_LOADER_STATE["DISABLED"] = "DISABLED";
})(PROCESSING_LOADER_STATE || (exports.PROCESSING_LOADER_STATE = PROCESSING_LOADER_STATE = {}));
var USER_MESSAGE_TEMPLATE;
(function (USER_MESSAGE_TEMPLATE) {
    USER_MESSAGE_TEMPLATE["RAW_MESSAGE"] = "RAW_MESSAGE";
    USER_MESSAGE_TEMPLATE["BRAND_PERMISSION_MESSAGE"] = "BRAND_PERMISSION_MESSAGE";
})(USER_MESSAGE_TEMPLATE || (exports.USER_MESSAGE_TEMPLATE = USER_MESSAGE_TEMPLATE = {}));
var APP_THEME;
(function (APP_THEME) {
    APP_THEME["LIGHT"] = "LIGHT";
    APP_THEME["DARK"] = "DARK";
})(APP_THEME || (exports.APP_THEME = APP_THEME = {}));
var CTA_BUTTON_STYLE;
(function (CTA_BUTTON_STYLE) {
    CTA_BUTTON_STYLE["YES_NO"] = "YES_NO";
    CTA_BUTTON_STYLE["ALLOW"] = "ALLOW";
})(CTA_BUTTON_STYLE || (exports.CTA_BUTTON_STYLE = CTA_BUTTON_STYLE = {}));
var TRANSACTION_SPEED;
(function (TRANSACTION_SPEED) {
    TRANSACTION_SPEED["FAST"] = "FAST";
    TRANSACTION_SPEED["INSANE"] = "INSANE";
})(TRANSACTION_SPEED || (TRANSACTION_SPEED = {}));
var GET_WALLET_AUTH;
(function (GET_WALLET_AUTH) {
    GET_WALLET_AUTH["UNKNOWN"] = "UNKNOWN";
    GET_WALLET_AUTH["DEFAULT"] = "DEFAULT";
    GET_WALLET_AUTH["ENABLED_ALWAYS"] = "ENABLED_ALWAYS";
})(GET_WALLET_AUTH || (exports.GET_WALLET_AUTH = GET_WALLET_AUTH = {}));
var WALLET_SCOPE_TYPE;
(function (WALLET_SCOPE_TYPE) {
    WALLET_SCOPE_TYPE["UNKNOWN_WALLET_SCOPE_TYPE"] = "UNKNOWN_WALLET_SCOPE_TYPE";
    WALLET_SCOPE_TYPE["GLOBAL"] = "GLOBAL";
    WALLET_SCOPE_TYPE["THIS_APPLICATION"] = "THIS_APPLICATION";
    WALLET_SCOPE_TYPE["OTHER_APPLICATION"] = "OTHER_APPLICATION";
})(WALLET_SCOPE_TYPE || (exports.WALLET_SCOPE_TYPE = WALLET_SCOPE_TYPE = {}));
const getAppUpdateRequestBody = (initialApp, updatedValues) => {
    var _a, _b, _c, _d, _e, _f;
    const { deletedKeys = [], newKeys = [], updatedKeys = [], whitelistedOrigins = [], } = updatedValues;
    const { whitelistedOrigins: existingWhitelistedOrigins = [] } = initialApp;
    const body = {
        appId: initialApp.appId,
    };
    let apiKeys = {};
    // check name
    if ((updatedValues === null || updatedValues === void 0 ? void 0 : updatedValues.name) && initialApp.name !== updatedValues.name)
        body.name = updatedValues.name;
    // check transaction speed
    if (initialApp.transactionSpeed !== updatedValues.transactionSpeed)
        body.transactionSpeed = updatedValues.transactionSpeed;
    // check deleted keys
    if (deletedKeys.length) {
        apiKeys.deleteApiKeys = [...deletedKeys];
        body.apiKeys = apiKeys;
    }
    // check new keys
    if (newKeys.length) {
        apiKeys.addApiKeys = [...newKeys];
        body.apiKeys = apiKeys;
    }
    // check updated keys
    if (updatedKeys.length) {
        apiKeys.updateApiKeys = [...updatedKeys];
        body.apiKeys = apiKeys;
    }
    if (initialApp.state !== updatedValues.state)
        body.state = updatedValues.state;
    if ((initialApp === null || initialApp === void 0 ? void 0 : initialApp.apiSignatureRequired) !== updatedValues.apiSignatureRequired)
        body.apiSignatureRequired = updatedValues.apiSignatureRequired;
    const userWallet = {};
    // theme check
    if (initialApp.appTheme !== updatedValues.appTheme) {
        userWallet.theme = {};
        userWallet.theme.style = updatedValues.appTheme;
    }
    // check skipFinalScreen
    if (initialApp.skipFinalScreen !== updatedValues.skipFinalScreen)
        userWallet.skipFinalScreen = updatedValues.skipFinalScreen;
    // check button color
    if (updatedValues.secondaryColor &&
        updatedValues.secondaryColor !== initialApp.secondaryColor)
        userWallet.button = {
            backgroundColor: updatedValues.secondaryColor,
        };
    // check display name
    if (updatedValues.displayName !== initialApp.displayName)
        userWallet.displayName = updatedValues.displayName;
    // check whitelisted origins
    if (JSON.stringify(whitelistedOrigins) !==
        JSON.stringify(existingWhitelistedOrigins))
        userWallet.whitelistedOrigins = [...whitelistedOrigins];
    // check user message template
    if (initialApp.userWallet.userMessageTemplate !==
        updatedValues.userWallet.userMessageTemplate)
        userWallet.userMessageTemplate =
            updatedValues.userWallet.userMessageTemplate;
    // check app logo url
    if (initialApp.appLogoUrl !== updatedValues.appLogoUrl)
        userWallet.logoUrl = updatedValues.appLogoUrl;
    if (initialApp.userWallet.customCss !== updatedValues.userWallet.customCss)
        userWallet.customCss = updatedValues.userWallet.customCss;
    if (initialApp.hideWalletOperationDetailsSection !==
        updatedValues.hideWalletOperationDetailsSection)
        userWallet.hideWalletOperationDetailsSection =
            updatedValues.hideWalletOperationDetailsSection;
    if (initialApp.userWallet.ctaButtonStyle !==
        updatedValues.userWallet.ctaButtonStyle)
        userWallet.ctaButtonStyle = updatedValues.userWallet.ctaButtonStyle;
    if (initialApp.hideUserProfileSection !== updatedValues.hideUserProfileSection)
        userWallet.hideUserProfileSection = updatedValues.hideUserProfileSection;
    if (initialApp.userWallet.fontName !== updatedValues.fontName)
        userWallet.fontName = updatedValues.userWallet.fontName;
    if (initialApp.userWallet.fontSizeScaling !== updatedValues.fontSizeScaling)
        userWallet.fontSizeScaling = updatedValues.userWallet.fontSizeScaling;
    // Check processing loader
    if (initialApp.userWallet.processingLoader !== updatedValues.processingLoader)
        userWallet.processingLoader = updatedValues.processingLoader;
    if (((_b = (_a = initialApp.userWallet.authProviders) === null || _a === void 0 ? void 0 : _a.phone) === null || _b === void 0 ? void 0 : _b.state) !==
        ((_d = (_c = updatedValues.authProviders) === null || _c === void 0 ? void 0 : _c.phone) === null || _d === void 0 ? void 0 : _d.state)) {
        // Set the new state
        userWallet.authProviders = {};
        userWallet.authProviders.phone = {
            state: (_f = (_e = updatedValues.authProviders) === null || _e === void 0 ? void 0 : _e.phone) === null || _f === void 0 ? void 0 : _f.state,
        };
    }
    // Check get wallet auth
    if (initialApp.userWallet.getWalletAuth !== updatedValues.getWalletAuth)
        userWallet.getWalletAuth = updatedValues.getWalletAuth;
    // Check wallet scope
    if (JSON.stringify(initialApp.userWallet.walletScope) !==
        JSON.stringify(updatedValues.walletScope))
        userWallet.walletScope = updatedValues.walletScope;
    if (Object.keys(userWallet).length)
        body.userWallet = userWallet;
    return body;
};
exports.getAppUpdateRequestBody = getAppUpdateRequestBody;
const getAppDataFromLegacyOrUpdatedFields = (appData) => {
    const { userWallet = {} } = appData;
    const { theme = {}, button = {}, whitelistedOrigins, skipFinalScreen, displayName, logoUrl, } = userWallet;
    const { style = "" } = theme;
    const { backgroundColor = "" } = button;
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, appData), { state: appData.state || constants_1.ENABLED, apiSignatureRequired: appData.apiSignatureRequired || false, userWallet: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, userWallet), { processingLoader: userWallet.processingLoader || PROCESSING_LOADER_STATE.ENABLED }), (!userWallet.hasOwnProperty("customCss")
            ? { customCss: "" }
            : { customCss: userWallet.customCss })), (!userWallet.hasOwnProperty("fontName")
            ? { fontName: "" }
            : { fontName: userWallet.fontName })), (!userWallet.hasOwnProperty("fontSizeScaling")
            ? { fontSizeScaling: "1" }
            : { fontSizeScaling: userWallet.fontSizeScaling })), (userWallet.hasOwnProperty("getWalletAuth")
            ? { getWalletAuth: userWallet.getWalletAuth }
            : { getWalletAuth: GET_WALLET_AUTH.DEFAULT })), (userWallet.hasOwnProperty("walletScope")
            ? { walletScope: userWallet.walletScope }
            : {})) }), (style ? { appTheme: style } : {})), (backgroundColor ? { secondaryColor: backgroundColor } : {})), (whitelistedOrigins
        ? {
            whitelistedOrigins: whitelistedOrigins,
        }
        : {})), (userWallet.hasOwnProperty("skipFinalScreen")
        ? { skipFinalScreen: skipFinalScreen }
        : { skipFinalScreen: false })), (displayName ? { displayName: displayName } : { displayName: "" })), (logoUrl ? { appLogoUrl: logoUrl } : { appLogoUrl: "" })), (userWallet.hasOwnProperty("hideWalletOperationDetailsSection")
        ? {
            hideWalletOperationDetailsSection: userWallet.hideWalletOperationDetailsSection,
        }
        : { hideWalletOperationDetailsSection: false })), (userWallet.hasOwnProperty("hideUserProfileSection")
        ? { hideUserProfileSection: userWallet.hideUserProfileSection }
        : { hideUserProfileSection: false }));
};
exports.getAppDataFromLegacyOrUpdatedFields = getAppDataFromLegacyOrUpdatedFields;
const getNormalizedCost = (value, chainId) => {
    if (value === "" || !chainId) {
        return "N/A";
    }
    const cost = new bignumber_js_1.BigNumber(value);
    const decimalPlaces = constants_2.CHAIN_CONFIG[chainId]["decimal"];
    const divisor = new bignumber_js_1.BigNumber(10).exponentiatedBy(decimalPlaces);
    return Number(cost
        .dividedBy(divisor)
        .toNumber()
        .toFixed(constants_2.CHAIN_CONFIG[chainId]["display_precision"]));
};
exports.getNormalizedCost = getNormalizedCost;
const formatTotalCost = (totalCost, chainId) => {
    if (totalCost === "" || !chainId) {
        return "N/A";
    }
    return `${Number(totalCost).toFixed(constants_2.CHAIN_CONFIG[chainId]["display_precision"])} ${constants_2.CHAIN_CONFIG[chainId]["symbol"]}`;
};
exports.formatTotalCost = formatTotalCost;
const captlizeFirstLetterOnly = (str = "") => {
    if (typeof str !== "string" || str.length === 0)
        return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
exports.captlizeFirstLetterOnly = captlizeFirstLetterOnly;
